import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { UiService } from '@services/index';
@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styleUrls: ['./phone-input.component.scss']
})
export class PhoneInputComponent implements OnInit, OnChanges {
  @Input() name: string;
  @Input() value: string;
  @Input() disabled: boolean = false;
  @Input() error: string;
  @Input() placeholder: string = 'Placeholder';
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  countries: any[];
  countryCode: string = '+995';
  country: any;
  phoneNumber: string;
  listState: boolean = false;

  constructor(private uiService: UiService) {
  }

  ngOnInit() {
    if(this.value){
      if(this.value.split(' ').length > 1){
        this.phoneNumber = this.value.split(' ')[1];
        this.countryCode = this.value.split(' ')[0];
      }else{
        this.phoneNumber = this.value;
      }
    }
    this.getCountriesCode();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.value){
      if(this.value.split(' ').length > 1){
        this.phoneNumber = this.value.split(' ')[1];
        this.countryCode = this.value.split(' ')[0];
      }else{
        this.phoneNumber = this.value;
      }
    }
  }

  // getCountriesCode(){
  //   this.uiService.getCountries().subscribe(data=>{
  //     this.countries = data;
  //     this.country = this.countries.find(x => x.phoneCode === this.countryCode);
  //   });
  // }

  getCountriesCode() {
    this.uiService.getCountries().subscribe(data => {
      // Sort countries alphabetically by name
      this.countries = data.sort((a: any, b: any) => a.name.localeCompare(b.name));
      this.country = this.countries.find((x: any) => x.phoneCode === this.countryCode);
    });
  }

  onChangeCounrtySelection(event){
    this.countryCode = event.phoneCode;
    this.country = event;
    this.listState = false;
    this.change();
  }

  change(){
    if(this.phoneNumber.length > 0 && this.countryCode){
      const payload = {
        name: this.name,
        value: this.countryCode + ' ' + this.phoneNumber
      }
      this.onChange.emit(payload)
    }
    
  }

}
